import React from "react";
import { Link } from "react-router-dom";

const NotFound404 = () => (
  <div className="account account--photo">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            <span className="account__logo">
              Lime
              <span className="account__logo-accent">Proxies</span>
            </span>
          </h3>
        </div>
        <h3 className="not-found__info">
          Ooops! The page you are looking for could not be found :(
        </h3>
        <Link className="btn btn-primary" to="/">
          Back Home
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound404;
